export const GRAMMAR_MASTERY_STATES = ['new', 'learning', 'strong', 'mastered', 'fading'] as const;
